
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosRequestConfig, AxiosResponse } from 'axios';
	const defaultRequestHeaders = {
		'X-Requested-With': 'XMLHttpRequest',
		'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1'
	};

export class ClientBase {
	protected async transformOptions(options: AxiosRequestConfig): Promise<AxiosRequestConfig> {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const dynamicHeaders = {}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		options.transformResponse = [];
		options.headers = { ...dynamicHeaders, ...options.headers, ...defaultRequestHeaders };
		return options;
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	protected transformResult(url: string, response: AxiosResponse, processor: (response: AxiosResponse) => any) {
		return processor(response);
	}
}
